module.exports = __webpack_public_path__ + "img/cart-masterclass-bottle-paid@2x.29205563.png";